import { Card, Text } from "@engaging-tech/components"
import React from "react"

import ResendEmail from "./resendEmail"

const EmailResent = ({ t, getData, setEmailResent }) => {
  return (
    <Card pt={[5, 5, 6]} pb={[6, 5]} elevation={8} bg="light.0" alignItems="center">
      <Text fontSize={[3, 4]} textAlign="center" fontWeight="500" display="block" pb={4}>
        {t("thankyou.email_sent", "")}
      </Text>
      <ResendEmail t={t} sendEmail={getData} setEmailResent={setEmailResent} />
    </Card>
  )
}

export default EmailResent
